import { render, staticRenderFns } from "./EditAttachmentModal.vue?vue&type=template&id=32eec76c&scoped=true"
import script from "./EditAttachmentModal.vue?vue&type=script&lang=js"
export * from "./EditAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eec76c",
  null
  
)

export default component.exports